(function () {

    "use strict";

    angular
        .module("harriApp")
        .service("interviewBankDataService", InterviewBankDataService);

    InterviewBankDataService.$inject = ['$q', 'userServices', 'brandServices', 'userPermissions', 'hUser'];

    function InterviewBankDataService($q, userServices, brandServices, userPermissions, hUser) {

        var self = this;
        var _emitter = JarEventEmitter.call(self);
        var _serviceType = "QUESTION_BANK";

        self.setServiceType = function (serviceType) {
            _serviceType = serviceType;
        };

        self.getServiceType = function () {
            return _serviceType;
        };

        var brandQuestionBankSettings = {};

        self.INTERVIEW_STATUS = {
            IN_PROGRESS: "IN_PROGRESS",
            PAUSED: "PAUSED",
            FINISHED: "FINISHED"
        };

        self.EVALUATION_TYPE = {
            PHONE: "PHONE",
            JOB: "JOB",
            JOB_SECOND_INTERVIEW: "JOB_SECOND_INTERVIEW",
        };

        self.INTERVIEW_QUESTION_TYPE = {
            TEXT: "TEXT",
            SINGLE: "SINGLE_CHOICE",
            MULTI: "MULTIPLE_CHOICE"
        };

        self.VIDEO_QUESTION_TYPE = {
            TEXT: "TEXT",
            VIDEO: "VIDEO",
            TEXT_OR_VIDEO: "TEXT_OR_VIDEO"
        };

        self.VIDEO_INTERVIEW_REVIEWER_TYPE = {
            CAN_NOT_REVIEW: 'CAN_NOT_REVIEW',
            CAN_REVIEW: 'CAN_REVIEW',
        }

        self.getQuestion = function (brandId, questionId) {
            return QuestionBankAPI.getQuestion(brandId, questionId, _serviceType);
        };

        self.getTemplateById = function (brandId, templateId) {
            return QuestionBankAPI.getTemplateById(brandId, templateId, _serviceType);
        };

        self.saveBrandTemplates = function (brandId, templateId, template, brands, positions, questions, status) {
            var defer = $q.defer();

            for (var i in questions) {
                questions[i].order = parseInt(i);
            }

            var payload = {
                name: template.name,
                type: template.type,
                opening_message: template.opening_message,
                closing_message: template.closing_message,
                scoring_mode: template.scoring_mode,
                description: template.description,
                media: template.media,
                status: status,
                questions: questions,
                brands: brands,
                positions: positions
            };

            if (templateId) {
                QuestionBankAPI.editTemplates(brandId, templateId, payload, _serviceType)
                    .then(function (data) {
                        defer.resolve(data);
                    }, function (err) {
                        console.error(err);
                        defer.reject(err);
                    });
            }
            else {
                QuestionBankAPI.saveTemplates(brandId, payload, _serviceType)
                    .then(function (data) {
                        defer.resolve(data);
                    }, function (err) {
                        console.error(err);
                        defer.reject(err);
                    });
            }


            return defer.promise;
        };

        self.saveBrandQuestions = function (brandId, questions) {

            questions = angular.copy(questions);

            for (var i in questions) {
                questions[i].type.id = parseInt(questions[i].type.id);

                if (questions[i].answer_type === 'TEXT') {
                    delete questions[i].options;
                }
            }

            if (questions[0] && questions[0].id) {
                return QuestionBankAPI.updateQuestion(brandId, questions[0].id, questions[0], _serviceType);
            }
            else {
                return QuestionBankAPI.saveQuestions(brandId, questions, _serviceType);
            }
        };

        self.getBrandQuestionTypes = function (brandId, questionTypeFilter) {

            var deferred = $q.defer();

            QuestionBankAPI
                .getBrandQuestionTypes(brandId, questionTypeFilter, _serviceType)
                .then(function (data) {
                    deferred.resolve(data);
                }, function (err) {
                    deferred.reject(err);
                });

            return deferred.promise;
        };

        var anyPermission = function (policyParser) {
            return policyParser.has(userPermissions.PERMISSIONS.MANAGE_VIDEO_INTERVIEW_TEMPLATES) ||
                policyParser.has(userPermissions.PERMISSIONS.MANAGE_VIDEO_INTERVIEW_QUESTION_TYPES) ||
                policyParser.has(userPermissions.PERMISSIONS.MANAGE_VIDEO_INTERVIEW_MEDIA);
        };

        self.getInterviewV2Settings = function (brandId) {
            var deferred = $q.defer();

            InterviewV2API.getSettings(brandId).then(function (res) {
                deferred.resolve(res['settings']);
            }).catch(function (err) {
                deferred.reject(err);
                console.log(err);
            });
            return deferred.promise;
        };

        var anyNotForced = function (brandSettings) {
            return !brandSettings.is_forced || !brandSettings.is_question_type_forced || !brandSettings.is_media_forced;
        };

        var sequenceChecker = function (policyParser, brandSettings, checkerLevelStatus) {
            if (policyParser.has(userPermissions.PERMISSIONS.MANAGE_VIDEO_INTERVIEW_TEMPLATES) &&
                !brandSettings.is_forced && checkerLevelStatus === 'templates') {
                return true;
            } else if (policyParser.has(userPermissions.PERMISSIONS.MANAGE_VIDEO_INTERVIEW_QUESTION_TYPES) &&
                !brandSettings.is_question_type_forced && checkerLevelStatus === 'types') {
                return true;
            } else if (policyParser.has(userPermissions.PERMISSIONS.MANAGE_VIDEO_INTERVIEW_MEDIA) &&
                !brandSettings.is_media_forced && checkerLevelStatus === 'media') {
                return true;
            }
            return false;
        };

        var determineRedirectLevel = function () {
            let state;
            if (hUser.isTopLevelContext()) {
                state = "appLayout.harriSH.access-portal.main";
            } else {
                state = "appLayout.harriSH.dashboard";
            }
            return {
                redirectToWorkspace: true,
                state
            }
        };

        self.checkPermissionsAndSettings = function (brandId, toState) {
            var deferred = $q.defer();

            var promises = {};
            promises['policyParser'] = userPermissions.getBrandPolicy(brandId);
            promises['isVideoInterviewEnabled'] = brandServices.check(brandServices.SERVICES.VIDEO_INTERVIEW, brandId);
            promises['brandSettings'] = self.getBrandQuestionBankSettings(brandId, false, self.SERVICE_TYPES.VIDEO_INTERVIEW);

            $q.all(promises)
                .then(function (res) {
                    if (res.isVideoInterviewEnabled) {
                        if (anyPermission(res.policyParser) && anyNotForced(res.brandSettings)) {
                            if (['appLayout.harriSH.video-interview-questions', 'appLayout.harriSH.video-interview-templates', 'appLayout.harriSH.video-interview-question', 'appLayout.harriSH.video-interview-template'].indexOf(toState) > -1) {
                                if (sequenceChecker(res.policyParser, res.brandSettings,'templates')) {
                                    deferred.resolve({state: toState});
                                } else if (sequenceChecker(res.policyParser, res.brandSettings,'types')) {
                                    deferred.resolve({state: 'appLayout.harriSH.video-interview-types'});
                                } else if (sequenceChecker(res.policyParser, res.brandSettings,'media')) {
                                    deferred.resolve({state: 'appLayout.harriSH.video-interview-media'});
                                } else {
                                    deferred.resolve(determineRedirectLevel());
                                }
                            } else if (['appLayout.harriSH.video-interview-types'].indexOf(toState) > -1) {
                                if (sequenceChecker(res.policyParser, res.brandSettings,'types')) {
                                    deferred.resolve({state: toState});
                                } else if (sequenceChecker(res.policyParser, res.brandSettings,'templates')) {
                                    deferred.resolve({state: 'appLayout.harriSH.video-interview-questions'});
                                } else if (sequenceChecker(res.policyParser, res.brandSettings,'media')) {
                                    deferred.resolve({state: 'appLayout.harriSH.video-interview-media'});
                                } else {
                                    deferred.resolve(determineRedirectLevel());
                                }
                            } else if (['appLayout.harriSH.video-interview-media'].indexOf(toState) > -1) {
                                if (sequenceChecker(res.policyParser, res.brandSettings,'media')) {
                                    deferred.resolve({state: toState});
                                } else if (sequenceChecker(res.policyParser, res.brandSettings,'templates')) {
                                    deferred.resolve({state: 'appLayout.harriSH.video-interview-questions'});
                                } else if (sequenceChecker(res.policyParser, res.brandSettings,'types')) {
                                    deferred.resolve({state: 'appLayout.harriSH.video-interview-types'});
                                } else {
                                    deferred.resolve(determineRedirectLevel());
                                }
                            } else  if (['appLayout.harriSH.access-portal.video-interview-questions', 'appLayout.harriSH.access-portal.video-interview-templates', 'appLayout.harriSH.access-portal.video-interview-question', 'appLayout.harriSH.access-portal.video-interview-template-new', 'appLayout.harriSH.access-portal.video-interview-template-edit'].indexOf(toState) > -1) {
                                if (sequenceChecker(res.policyParser, res.brandSettings,'templates')) {
                                    deferred.resolve({state: toState});
                                } else if (sequenceChecker(res.policyParser, res.brandSettings,'types')) {
                                    deferred.resolve({state: 'appLayout.harriSH.access-portal.video-interview-types'});
                                } else if (sequenceChecker(res.policyParser, res.brandSettings,'media')) {
                                    deferred.resolve({state: 'appLayout.harriSH.access-portal.video-interview-media'});
                                } else {
                                    deferred.resolve(determineRedirectLevel());
                                }
                            } else if (['appLayout.harriSH.access-portal.video-interview-types'].indexOf(toState) > -1) {
                                if (sequenceChecker(res.policyParser, res.brandSettings,'types')) {
                                    deferred.resolve({state: toState});
                                } else if (sequenceChecker(res.policyParser, res.brandSettings,'templates')) {
                                    deferred.resolve({state: 'appLayout.harriSH.access-portal.video-interview-questions'});
                                } else if (sequenceChecker(res.policyParser, res.brandSettings,'media')) {
                                    deferred.resolve({state: 'appLayout.harriSH.access-portal.video-interview-media'});
                                } else {
                                    deferred.resolve(determineRedirectLevel());
                                }
                            } else if (['appLayout.harriSH.access-portal.video-interview-media'].indexOf(toState) > -1) {
                                if (sequenceChecker(res.policyParser, res.brandSettings,'media')) {
                                    deferred.resolve({state: toState});
                                } else if (sequenceChecker(res.policyParser, res.brandSettings,'templates')) {
                                    deferred.resolve({state: 'appLayout.harriSH.access-portal.video-interview-questions'});
                                } else if (sequenceChecker(res.policyParser, res.brandSettings,'types')) {
                                    deferred.resolve({state: 'appLayout.harriSH.access-portal.video-interview-types'});
                                } else {
                                    deferred.resolve(determineRedirectLevel());
                                }
                            }
                        } else {
                            deferred.resolve(determineRedirectLevel());
                        }
                    } else {
                        deferred.resolve(determineRedirectLevel());
                    }
                })
                .catch(function (err) {
                    console.error(err);
                    deferred.resolve(determineRedirectLevel());
                });

            return deferred.promise;
        };

        self.saveBrandQuestionTypes = function (brandId, questionsTypes) {

            var defer = $q.defer();

            QuestionBankAPI.saveBrandQuestionTypes(brandId, questionsTypes, _serviceType)
                .then(function (data) {
                    defer.resolve(data);

                }, function (err) {
                    console.error(err);
                    defer.reject(err);
                });

            return defer.promise;
        };

        self.getAllQuestions = function (brandId, offset, limit, types, term) {

            var deferred = $q.defer();

            QuestionBankAPI
                .getAllQuestions(brandId, offset, limit, types, term, _serviceType)
                .then(function (data) {
                    deferred.resolve(data);
                }, function (err) {
                    deferred.reject(err);
                });

            return deferred.promise;
        };

        self.deleteQuestion = function (brandId, questionId) {

            var deferred = $q.defer();

            QuestionBankAPI
                .deleteQuestion(brandId, questionId, _serviceType)
                .then(function (data) {
                    deferred.resolve(data);
                }, function (err) {
                    deferred.reject(err);
                });

            return deferred.promise;
        };

        self.postMedia = function (brandId, param) {

            var deferred = $q.defer();

            QuestionBankAPI
                .postMedia(brandId, _serviceType, param)
                .then(function (data) {
                    deferred.resolve(data);
                }, function (err) {
                    deferred.reject(err);
                });

            return deferred.promise;
        };

        self.deleteMedia = function (brandId, mediaId) {

            var deferred = $q.defer();

            QuestionBankAPI
                .deleteMedia(brandId, _serviceType, mediaId)
                .then(function (data) {
                    deferred.resolve(data);
                }, function (err) {
                    deferred.reject(err);
                });

            return deferred.promise;
        };

        self.getSignedUrl = function (brandId, param) {

            var deferred = $q.defer();

            QuestionBankAPI
                .getSignedUrl(brandId, _serviceType, param)
                .then(function (data) {
                    deferred.resolve(data);
                }, function (err) {
                    deferred.reject(err);
                });

            return deferred.promise;
        };

        self.getMedia = function (brandId, param) {

            var deferred = $q.defer();

            QuestionBankAPI
                .getMedia(brandId, _serviceType, param)
                .then(function (data) {
                    deferred.resolve(data);
                }, function (err) {
                    deferred.reject(err);
                });

            return deferred.promise;
        };

        self.getMyVideoInterviews = function (param) {

            var deferred = $q.defer();

            QuestionBankAPI
                .getMyVideoInterviews(param, self.SERVICE_TYPES.VIDEO_INTERVIEW)
                .then(function (data) {
                    deferred.resolve(data);
                }, function (err) {
                    deferred.reject(err);
                });

            return deferred.promise;
        };

        self.startEvaluation = function (brandId, applicationId, templateId, type) {

            var deferred = $q.defer();

            QuestionBankAPI
                .startEvaluation(brandId, applicationId, templateId, type, self.SERVICE_TYPES.QUESTION_BANK)
                .then(function (data) {
                    deferred.resolve(data);
                }, function (err) {
                    deferred.reject(err);
                });

            return deferred.promise;
        };

        self.saveEvaluation = function (brandId, applicationId, evaluationId, status, answers) {

            var deferred = $q.defer();

            QuestionBankAPI
                .saveEvaluation(brandId, applicationId, evaluationId, status, answers, self.SERVICE_TYPES.QUESTION_BANK)
                .then(function (data) {
                    deferred.resolve(data);
                }, function (err) {
                    deferred.reject(err);
                });

            return deferred.promise;
        };

        self.updateEvaluationQuestionAnswers = function (brandId, applicationId, evaluationId, questionId, payload) {

            var deferred = $q.defer();

            QuestionBankAPI
                .updateEvaluationQuestionAnswers(brandId, applicationId, evaluationId, questionId, payload, self.SERVICE_TYPES.QUESTION_BANK)
                .then(function (data) {
                    deferred.resolve(data);
                }, function (err) {
                    deferred.reject(err);
                });

            return deferred.promise;
        };

        self.getEvaluationDetails = function (brandId, applicationId, evaluationId) {

            var deferred = $q.defer();

            QuestionBankAPI
                .getEvaluationDetails(brandId, applicationId, evaluationId, self.SERVICE_TYPES.QUESTION_BANK)
                .then(function (data) {
                    deferred.resolve(data);
                }, function (err) {
                    deferred.reject(err);
                });

            return deferred.promise;
        };

        self.getEvaluationResults = function (brandId, applicationId, type) {

            var deferred = $q.defer();

            QuestionBankAPI
                .getEvaluationResults(brandId, applicationId, type, self.SERVICE_TYPES.QUESTION_BANK)
                .then(function (data) {
                    deferred.resolve(data);
                }, function (err) {
                    deferred.reject(err);
                });

            return deferred.promise;
        };

        self.getJobAttachedTemplates = function (brandId, jobId, serviceType) {

            var tempServiceType = serviceType;
            if (!tempServiceType) {
                tempServiceType = _serviceType;
            }

            var deferred = $q.defer();

            QuestionBankAPI
                .getJobAttachedTemplates(brandId, jobId, tempServiceType)
                .then(function (data) {
                    deferred.resolve(data);
                }, function (err) {
                    deferred.reject(err);
                });

            return deferred.promise;
        };

        self.getAllTemplates = function (brandId, limit, offset, types, positions, searchTerm, brandIds, filterBy, statuses, serviceType, includeArchived) {

            var tempServiceType = serviceType;
            if (!tempServiceType) {
                tempServiceType = _serviceType;
            }

            var deferred = $q.defer();

            QuestionBankAPI
                .getAllTemplates(brandId, limit, offset, types, positions, searchTerm, brandIds, filterBy, statuses, tempServiceType, includeArchived)
                .then(function (data) {
                    deferred.resolve(data);
                }, function (err) {
                    deferred.reject(err);
                });

            return deferred.promise;
        };

        self.deleteTemplate = function (brandId, templateId) {

            var deferred = $q.defer();

            QuestionBankAPI
                .deleteTemplate(brandId, templateId, _serviceType)
                .then(function (data) {
                    deferred.resolve(data);
                }, function (err) {
                    deferred.reject(err);
                });

            return deferred.promise;
        };

        self.getBrandQuestionBankSettings = function (brandId, includeChildren, serviceType) {

            var deferred = $q.defer();

            var params = {};

            var tempServiceType = serviceType;
            if (!tempServiceType) {
                tempServiceType = _serviceType;
            }

            if (includeChildren) {
                params['include_children'] = includeChildren;
            }

            if (brandQuestionBankSettings[tempServiceType] && brandQuestionBankSettings[tempServiceType][brandId]) {
                deferred.resolve(brandQuestionBankSettings[tempServiceType][brandId]);
            }
            else {
                QuestionBankAPI
                    .getBrandQuestionBankSettings(brandId, params, tempServiceType)
                    .then(function (data) {
                        brandQuestionBankSettings[tempServiceType] = brandQuestionBankSettings[tempServiceType] || {};
                        brandQuestionBankSettings[tempServiceType][brandId] = data;

                        if (data && data.children_settings && data.children_settings.length) {

                            for (var c in data.children_settings) {

                                var childSettings = data.children_settings[c];

                                brandQuestionBankSettings[tempServiceType] = brandQuestionBankSettings[tempServiceType] || {};
                                brandQuestionBankSettings[childSettings.brand_id] = childSettings;
                            }
                        }

                        deferred.resolve(brandQuestionBankSettings[tempServiceType][brandId]);
                    }, function (err) {
                        deferred.reject(err);
                    });
            }

            return deferred.promise;
        };

        self.checkQuestionBankServiceSettings = function (brandId, type) {

            var deferred = $q.defer();

            userServices
                .isServiceEnabled(userServices.SERVICES.QUESTION_BANK, brandId)
                .then(function (isQuestionBankEnabled) {

                    if (isQuestionBankEnabled) {
                        self.getBrandQuestionBankSettings(brandId, false, self.SERVICE_TYPES.QUESTION_BANK)
                            .then(function (settings) {

                                var neededSettingVar = type + '_interview_enabled';

                                if (settings[neededSettingVar]) {
                                    deferred.resolve(settings[neededSettingVar]);
                                }
                                else {
                                    deferred.resolve(false);
                                }
                            }, function () {
                                deferred.resolve(false);
                            });
                    }
                    else {
                        deferred.resolve(false);
                    }
                }, function () {
                    deferred.resolve(false);
                });

            return deferred.promise;
        };

        self.saveBrandQuestionBankJobTemplates = function (brandId, jobId, jobInterviewTemplates, serviceType) {

            var tempServiceType = serviceType;
            if (!tempServiceType) {
                tempServiceType = _serviceType;
            }

            var deferred = $q.defer();

            QuestionBankAPI
                .saveBrandQuestionBankJobTemplates(brandId, jobId, jobInterviewTemplates, tempServiceType)
                .then(function (data) {
                    deferred.resolve(data);
                }, function (err) {
                    deferred.reject(err);
                });

            return deferred.promise;
        };

        self.sendVideoInterviewInvitation = function (brandId, serviceType, appIds) {

            if (_.isEmpty(appIds)) {
                throw 'no application id';
            }

            if (!brandId) {
                throw 'no brand id';
            }

            if (!serviceType) {
                throw 'no service type';
            }

            var tempServiceType = serviceType;
            if (!tempServiceType) {
                tempServiceType = _serviceType;
            }

            var deferred = $q.defer();

            QuestionBankAPI
                .sendVideoInterviewInvitation(brandId, tempServiceType, appIds)
                .then(function (data) {
                    deferred.resolve(data);
                })
                .catch(function (err) {
                    deferred.reject(err);
                });

            return deferred.promise;
        };

        self.resendVideoInterviewInvitation = function (brandId, serviceType, applicationId, interviewId) {

            if (!applicationId) {
                throw 'no application id';
            }

            if (!interviewId) {
                throw 'no interview id';
            }

            if (!brandId) {
                throw 'no brand id';
            }

            if (!serviceType) {
                throw 'no service type';
            }

            var tempServiceType = serviceType;
            if (!tempServiceType) {
                tempServiceType = _serviceType;
            }

            var deferred = $q.defer();

            QuestionBankAPI
                .resendVideoInterviewInvitation(brandId, tempServiceType, applicationId, interviewId)
                .then(function (data) {
                    deferred.resolve(data);
                })
                .catch(function (err) {
                    deferred.reject(err);
                });

            return deferred.promise;
        };

        self.withdrawVideoInterviewInvitation = function (brandId, serviceType, interviewIds) {

            if (_.isEmpty(interviewIds)) {
                throw 'no interview id';
            }

            if (!brandId) {
                throw 'no brand id';
            }

            if (!serviceType) {
                throw 'no service type';
            }

            var tempServiceType = serviceType;
            if (!tempServiceType) {
                tempServiceType = _serviceType;
            }

            var deferred = $q.defer();

            QuestionBankAPI
                .withdrawVideoInterviewInvitation(brandId, tempServiceType, interviewIds)
                .then(function (data) {
                    deferred.resolve(data);
                })
                .catch(function (err) {
                    deferred.reject(err);
                });

            return deferred.promise;
        };

        self.getApplicantInterview = function (brandId, serviceType, applicationId) {

            if (!applicationId) {
                throw 'no application id';
            }

            if (!brandId) {
                throw 'no brand id';
            }

            if (!serviceType) {
                throw 'no service type';
            }

            var tempServiceType = serviceType;
            if (!tempServiceType) {
                tempServiceType = _serviceType;
            }

            var deferred = $q.defer();

            QuestionBankAPI
                .getApplicantInterview(brandId, tempServiceType, applicationId)
                .then(function (data) {
                    deferred.resolve(data);
                })
                .catch(function (err) {
                    deferred.reject(err);
                });

            return deferred.promise;
        };

        self.postOverAllScore = function (brandId, serviceType, applicationId, interviewId, payload) {

            if (!applicationId) {
                throw 'no application id';
            }

            if (!brandId) {
                throw 'no brand id';
            }

            if (!serviceType) {
                throw 'no service type';
            }

            var tempServiceType = serviceType;
            if (!tempServiceType) {
                tempServiceType = _serviceType;
            }

            var deferred = $q.defer();

            QuestionBankAPI
                .postOverAllScore(brandId, tempServiceType, applicationId, interviewId, payload)
                .then(function (res) {
                    deferred.resolve(res);
                    _emitter.trigger("overAllReviewedSuccessfully", res);
                })
                .catch(function (err) {
                    deferred.reject(err);
                });

            return deferred.promise;
        };

        self.postReview = function (brandId, serviceType, applicationId, interviewId, questionId, answerId, payload, index) {

            if (!applicationId) {
                throw 'no application id';
            }

            if (!interviewId) {
                throw 'no interview id';
            }

            if (!questionId) {
                throw 'no question id';
            }

            if (!answerId) {
                throw 'no answer id';
            }

            if (!brandId) {
                throw 'no brand id';
            }

            if (!serviceType) {
                throw 'no service type';
            }

            var tempServiceType = serviceType;
            if (!tempServiceType) {
                tempServiceType = _serviceType;
            }

            var deferred = $q.defer();

            QuestionBankAPI
                .postReview(brandId, tempServiceType, applicationId, interviewId, questionId, answerId, payload)
                .then(function (res) {
                    deferred.resolve(res);
                    _emitter.trigger("reviewedSuccessfully", res, index, answerId, payload);
                })
                .catch(function (err) {
                    deferred.reject(err);
                    _emitter.trigger("failedToReview", index);
                });

            return deferred.promise;
        };

        self.getVideoInterviewStatuses = function (brandId, serviceType, applicantsIds) {
            var applicantsLimit = 100;

            if (!brandId) {
                throw 'no brand id';
            }

            if (!serviceType) {
                throw 'no service type';
            }

            if(!Array.isArray(applicantsIds)){
                var arrayIds = [];
                arrayIds.push(applicantsIds);
                applicantsIds = arrayIds;
            }

            var tempServiceType = serviceType;
            if (!tempServiceType) {
                tempServiceType = _serviceType;
            }

            var deferred = $q.defer();

            var promises = {};
            for (var i = 0; i < applicantsIds.length; i += applicantsLimit) {
                promises['' + i + '-' + (i + (applicantsLimit - 1))] = QuestionBankAPI.getVideoInterviewStatuses(brandId, tempServiceType, applicantsIds.slice(i, i + applicantsLimit));
            }

            $q.all(promises)
                .then(function (res) {
                    var applications = [];

                    if (res) {
                        for (var i in res) {
                            applications = applications.concat(res[i].applications);
                        }
                        deferred.resolve({applications: applications});
                    }
                })
                .catch(function (err) {
                    console.error(err);
                    deferred.reject(err);
                });

            return deferred.promise;
        };

        self.getVideoInterviewReviewers = function (brandId, serviceType, applicantsId, interviewId) {

            if (!brandId) {
                throw 'no brand id';
            }

            if (!applicantsId) {
                throw 'no applicants id';
            }

            if (!interviewId) {
                throw 'no interview id';
            }

            if (!serviceType) {
                throw 'no service type';
            }

            var tempServiceType = serviceType;
            if (!tempServiceType) {
                tempServiceType = _serviceType;
            }

            var deferred = $q.defer();

            QuestionBankAPI
                .getVideoInterviewReviewers(brandId, tempServiceType, applicantsId, interviewId)
                .then(function (data) {
                    deferred.resolve(data);
                })
                .catch(function (err) {
                    deferred.reject(err);
                });

            return deferred.promise;
        };

        self.getVideoInterviewBrandReviewers = function (brandId) {

            var deferred = $q.defer();
            QuestionBankAPI
                .getVideoInterviewBrandReviewers(brandId)
                .then(function (data) {
                    deferred.resolve(data);
                })
                .catch(function (err) {
                    deferred.reject(err);
                });

            return deferred.promise;
        };

        self.activateTemplate =  function (brandId, templateId) {

            var deferred = $q.defer();

            QuestionBankAPI
                .activateTemplate(brandId, templateId, _serviceType)
                .then(function (data) {
                    deferred.resolve(data);
                }, function (err) {
                    deferred.reject(err);
                });

            return deferred.promise;
        };

        self.deactivateTemplate =  function (brandId, templateId) {

            var deferred = $q.defer();

            QuestionBankAPI
                .deactivateTemplate(brandId, templateId, _serviceType)
                .then(function (data) {
                    deferred.resolve(data);
                }, function (err) {
                    deferred.reject(err);
                });

            return deferred.promise;
        };

        self.SERVICE_TYPES = {
            QUESTION_BANK: 'QUESTION_BANK',
            VIDEO_INTERVIEW: 'VIDEO_INTERVIEW'
        };

    }
})();